var React = require('react');

function TimelineArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.8059 13.6895V19.6059L10.243 21.0828L7.68007 22.5598L5.11715 24.0367L2.56292 25.5136V25.5223L0 26.9993V21.0828L2.56292 19.6059L5.11715 18.129L7.68007 16.652L10.243 15.1751V15.1664L12.8059 13.6895Z","fill":"#121212","key":0}),React.createElement("path",{"d":"M12.8059 7.78205V13.6898L10.243 12.2129L7.68007 10.7359L5.11715 9.25898L2.56292 7.78205L0 6.30511V0.388672L2.56292 1.86561L5.11715 3.34255L7.68007 4.81948L10.243 6.30511L12.8059 7.78205Z","fill":"#121212","key":1})]);
}

TimelineArrow.defaultProps = {"width":"13","height":"27","viewBox":"0 0 13 27","fill":"none"};

module.exports = TimelineArrow;

TimelineArrow.default = TimelineArrow;
